angular.module('bookAndPay').controller('CompleteCtrl', ["$scope", "$state", "DataService", "cart", function($scope, $state, DataService, cart) {
  $scope.cart = cart.plain();
  $scope.currency = DataService.currency;
  $scope.cartType = cart.cart_type === 'payment_only_cart' ? 'po' : void 0;
  return $scope.displayTime = function() {
    return moment(cart.event_start_at, 'YYYY/MM/DD HH:mma').format('ddd, D MMM [at] h:mm');
  };
}]);
